"use client"

import * as AvatarPrimitive from "@radix-ui/react-avatar"
import { type VariantProps } from "class-variance-authority"
import * as React from "react"

import { cn } from "../../helpers"
import * as styles from "./avatar.styled"

const Avatar = React.forwardRef<
  React.ComponentRef<typeof AvatarPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Root> &
    VariantProps<(typeof styles)["baseAvatarClassName"]> & {
      badge?: boolean
    }
>(({ className, size, disabled, backgroundColor, children, badge, ...props }, ref) => (
  <AvatarPrimitive.Root
    ref={ref}
    className={cn(styles.baseAvatarClassName({ size, disabled, backgroundColor }), className)}
    {...props}
  >
    {badge ? <div className={styles.badgeClassName({ size })}></div> : null}
    {children}
  </AvatarPrimitive.Root>
))
Avatar.displayName = "Avatar"

const AvatarImage = React.forwardRef<
  React.ComponentRef<typeof AvatarPrimitive.Image>,
  React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Image>
>(({ className, ...props }, ref) => (
  <AvatarPrimitive.Image ref={ref} className={styles.avatarImage(className)} {...props} />
))
AvatarImage.displayName = "AvatarImage"

export { Avatar, AvatarImage }
